import styled from 'styled-components'

import { orderStatuses } from '../constants'

export const StoreNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props =>
    props.status === orderStatuses.cancelled ? props.theme.colors.text.subtle : props.theme.colors.text.default};
`
